export const hasReviewableVarianceTarget = (row = {}, { mockMode = false } = {}) => (
  mockMode || Boolean(
    (row?.id || row?.varianceId || row?.variance_id)
    && (row?.updatedAt || row?.updated_at)
  )
);

export const reviewTargetFromDrawerRow = (row = {}, contextVariance = {}) => ({
  ...row,
  id: row?.id || row?.varianceId || row?.variance_id || contextVariance.id || contextVariance.varianceId || contextVariance.variance_id,
  varianceId: row?.varianceId || row?.id || row?.variance_id || contextVariance.varianceId || contextVariance.id || contextVariance.variance_id,
  updatedAt: row?.updatedAt || row?.updated_at || contextVariance.updatedAt || contextVariance.updated_at,
});
